import {AppStartListening} from "../../store";
import {ListenerEffectAPI, PayloadAction, Unsubscribe} from "@reduxjs/toolkit";
import {loadClubs} from "./asyncActions";
import {handleUserCreated, SessionState} from "../session/slice";
import {refreshSession} from "../session/asyncActions";
import {findSelectedClub, LoadClubsActionPayload} from "./slice";

const handleUserLoaded = async (_: any, listenerApi: ListenerEffectAPI<any, any>) => {
    let state = listenerApi.getState().session.sessionState
    if (state === SessionState.ACTIVE) {
        listenerApi.dispatch(loadClubs())
    }
}

const handleClubsLoaded = async (_: PayloadAction<LoadClubsActionPayload>, listenerApi: ListenerEffectAPI<any, any>) => {
    listenerApi.dispatch(findSelectedClub())
}

export function setupClubListeners(startListening: AppStartListening): Unsubscribe {
    const subscriptions = [
        startListening({
            actionCreator: refreshSession.fulfilled,
            effect: handleUserLoaded,
        }),
        startListening({
            actionCreator: handleUserCreated,
            effect: handleUserLoaded,
        }),
        startListening({
            actionCreator: loadClubs.fulfilled,
            effect: handleClubsLoaded,
        }),
    ]

    return () => {
        subscriptions.forEach((unsubscribe) => unsubscribe())
    }
}